
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["prt-icon prt-option-icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 102.8 102.8"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#b0b2b3","d":"M99.19 40.25V3.19H16.41v83.45h11.43v3.52h20.42v-3.52h50.93V40.25z"}}),_c('path',{staticClass:"prt-icon-color",attrs:{"d":"M76.63 1.5H63.74V0h12.89zm26.17 14.57h-1.5V1.5H89.39V0h13.41zm-88.72 1.16h-1.5V0h38.4v1.5h-36.9zm0 39.74h-1.5V30.76h1.5zm10.81 33.24H12.58V70.5h1.5v18.21h10.81zm53 0H50.98v-1.5h26.89zm24.94 0H90.62v-1.5h10.68V29.6h1.5z"}}),_c('path',{attrs:{"d":"M17.33 102.82h1v-5.55h-1zm4.69 0h1v-5.55h-1zm4.69 0h1v-5.55h-1zm4.7 0h1v-5.55h-1zm9.38 0h1v-5.55h-1zm4.69 0h1v-5.55h-1zm4.7 0h1v-5.55h-1.04zm4.69 0h1v-5.55h-1zm9.39 0h1v-5.55h-1zm4.69 0h1v-5.55h-1zm4.69 0h1v-5.55h-1zm4.69 0h1v-5.55h-1zm9.39 0h1v-5.55h-1zm4.69 0h1v-5.55h-1zm4.7 0h1v-5.55h-1zm4.69 0h1v-5.55h-1zm-65.66 0h1v-7.7h-1zm23.46 0h1v-7.7h-1zm23.47 0h1v-7.7h-1zm-70.43 0h1v-8.4h-1zM0 90.16h8.38v-1H0zm0-4.69h5.55v-1H0zm0-4.69h5.55v-1H0zm0-4.7h5.55v-1H0zm0-4.69h5.55v-1H0zm0-4.69h7.67v-1H0zm0-4.69h5.55v-1H0zm0-4.7h5.55v-1H0zm0-4.69h5.55v-1H0zm0-4.69h5.55v-1H0zm0-4.69h7.67v-1H0zm0-4.7h5.55v-1H0zm0-4.69h5.55v-1.03H0zm0-4.69h5.55v-1H0zm0-4.7h5.55v-1H0zm0-4.69h7.67v-.95H0zm0-4.69h5.55v-1H0zm0-4.69h5.55v-1H0zm0-4.7h5.55v-1H0zM0 1h5.55V0H0z","fill":"#9c9c9e"}})])
          )
        }
      }
    